
interface AdminLogoProps {
  className?: string;
}

export const AdminLogo = ({ className = "" }: AdminLogoProps) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/lovable-uploads/21bd0501-b2a5-4097-8de7-eb5f1ebf894b.png" 
        alt="Global Foodland" 
        className="h-10 w-auto mr-3"
      />
      <span className="ml-2 px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded">
        Admin Dashboard
      </span>
    </div>
  );
};
